module.exports = __webpack_public_path__ + "images/users/kaitori_focused_items/trading_cards/2_58d4788e6ab3d27dfa0a00dc249ec25b.jpg";